import React from "react";
import { Badge, Tooltip } from "@mui/material";
import { CodeOffOutlined } from "@mui/icons-material";

export const TabLabel = ({ tab }) => {
  if (!tab?.badgeContent) return <Label {...tab} />;

  if (tab?.badgeComponent) return tab.badgeComponent(tab);

  return (
    <Badge
      badgeContent={tab?.badgeContent ?? 0}
      color="primary"
      className="relative"
    >
      <Label {...tab} />

      {tab?.enablePulse && tab.badgeContent > 0 && (
        <span className="absolute -right-2.5 -top-2.5 z-auto inline-flex h-5 w-5 animate-ping rounded-full bg-sky-600 opacity-75"></span>
      )}
    </Badge>
  );
};

const Label = ({ label, inDevelopment }) => {
  return (
    <div className="mx-2 flex items-center gap-1">
      <span className="text-sm">{label}</span>

      {inDevelopment && (
        <Tooltip title="In Development">
          <CodeOffOutlined color="warning" fontSize="small" />
        </Tooltip>
      )}
    </div>
  );
};
